export const USER_POSITION_DRAWER_QUERY_KEY = 'employeeID'
